import { render } from "./SeatPlanCard.vue?vue&type=template&id=aba84d8e&scoped=true"
import script from "./SeatPlanCard.vue?vue&type=script&lang=js"
export * from "./SeatPlanCard.vue?vue&type=script&lang=js"

import "./SeatPlanCard.vue?vue&type=style&index=0&id=aba84d8e&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aba84d8e"]])

export default __exports__